<template>
  <v-dialog v-model="value" persistent max-width="600px" style="z-index:995">
    <v-card>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card-title class="border-y mx-auto">
        <v-row>
          <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
            <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
          </v-col>

          <v-col lg="4" md="6" cols="12" class="text-center align-self-center">
            <h2
              id="title"
              class="displayy-1 flex-grow-1"
              style="font-family:'Tajawal', sans-serif !important"
            >{{$t('Check Out') }}</h2>
          </v-col>

          <v-col lg="4" md="3" cols="12" class="text-center align-self-center">
            <v-divider style="border-width:1px;border-color:#2e368f"></v-divider>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-container>
          <v-form ref="form" v-model="valid">
            <!-- <v-img src="@/assets/logo.png" cover class="mx-auto" style="width:45%"></v-img> -->
            <v-text-field
              v-model="checkOut.name"
              :rules="nameRules"
              :label="$root.$t('Name')"
              required
            ></v-text-field>

            <v-text-field
              v-model="checkOut.email"
              :rules="emailRules"
              :label="$root.$t('E-mail')"
              
            ></v-text-field>
            <v-text-field
              v-model="checkOut.phone"
              :rules="phoneRules"
              :label="$root.$t('Phone Number')"
              required
            ></v-text-field>
            <v-text-field
              name="input-7-1"
              v-model="checkOut.address"
              :rules="addressRules"
              :label="$root.$t('Address')"
            ></v-text-field>
            <v-textarea
              name="input-7-1"
              v-model="checkOut.notes"
              :rules="notesRules"
              :label="$root.$t('Notes')"
            ></v-textarea>


  
            <p>{{$t('select_payment')}}</p>
           
            <input type="radio" id="cash" value="cash" v-model="payment_method">
            <label for="cash">  {{$t('pay_on_delivery') }}</label>
            <br>
            <input type="radio" id="syber" value="syber" v-model="payment_method">
            <label for="syber"> {{$t('pay_with_syber') }}</label>


    


          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!--  control buttons -->
        <v-btn outlined color="secondary" @click="close()">{{$t('Close') }}</v-btn>
        <v-btn color="secondary" outlined @click="confirm">{{$t('Confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: false,
    loading: false,

  },
  data: () => ({
    valid: true,
    payment_method: "cash",
    checkOut: {
      name: "",
      phone: "",
      email: "",
      address: "",
      notes: "",
      type: "normal",
      p_method: "cash"
    },
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 100) || "Name must be less than 100 characters"
    ],
    phoneRules: [
      v => !!v || "Phone number is required",
      v => v.length >= 10 && v.length < 15  || "Phone number must not be less than 10 characters"
    ],
    emailRules: [
    //   v => !!v || "E-mail is required",
      v => (/.+@.+\..+/.test(v) || v=='') || "E-mail must be valid"
    ],
    addressRules: [v => !!v || "Address is required"],
    // notesRules: [v => !!v || "Notes is required"]
  }),

  methods: {
    async confirm() {
      this.$refs.form.validate();
      if (this.valid){
        if(this.checkOut.email == '') this.checkOut.email = 'EmailNotEntered@error.com'
        if(this.payment_method == 'syber'){
          // this.checkOut.notes = 'This user used SyberPay (check this link to view payment status: )\n --  User notes:' + this.checkOut.notes;
          this.checkOut.p_method = 'syber';
        }
        this.$emit("confirm", this.checkOut);
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    close() {
      this.$refs.form.reset();
      this.$emit("input", false);
    }
  }
};
</script>

<style>
.border-y {
}

label{
  padding-left: 5px;
  padding-right: 5px;
}
</style>
